export default __webpack_public_path__ + "static/media/menuL_icon_01.68c9b793.png";